import React, { createContext, useContext, useState, useEffect } from 'react'
import { translations, getTranslation } from 'constants/translations'

const LanguageContext = createContext()

const LANGUAGE_STORAGE_KEY = 'emily_language'

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Get language from localStorage, default to Thai
    const savedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY)
    return savedLanguage || 'th'
  })

  useEffect(() => {
    // Save language to localStorage whenever it changes
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language)
  }, [language])

  const t = (key, defaultValue) => {
    return getTranslation(language, key, defaultValue)
  }

  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage)
  }

  const value = {
    language,
    changeLanguage,
    t, // translation function
    translations: translations[language] || translations.th
  }

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  )
}

export const useLanguage = () => {
  const context = useContext(LanguageContext)
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider')
  }
  return context
}